<div class="inner-box">
    <mat-card class="without-expansion">
        <mat-card-content class="d-flex flex-column form-head">
            <img style="width: 150px;" src="../../../assets/img/Logo.svg" alt="Sundeus Technology" />
            <strong class="mt-3">Sundeus CLM</strong>
                <span>Version: 1.0 Beta</span>
                <span>Release Date: 3rd Feb 2025</span>

            <strong class="mt-3">Browser Compatibility</strong>
            <span>1. Google Chrome Version 132.0.6834.159 (Official Build) (64-bit)</span>
            <span>2. Microsoft Edge Version 132.0.2957.115 (Official build) (64-bit)</span>

            <strong class="mt-3">For Help and Support</strong>
            <span>Reach us at:<a herf="mailto:sclm@sundeus.com"> sclm&#64;sundeus.com</a></span>
            <span>Visit Website:<a href="https://www.sundeus.com" target="_blank"> www.sundeus.com</a></span>
        </mat-card-content>
    </mat-card>
</div>